import {
	GET_SCHEDULES_WORKSHIFT,
	GET_SCHEDULES_WORKSHIFT_ERROR,
	GET_SCHEDULES_WORKSHIFT_SUCCESS,
} from '../../../constants';

export const getScheduleWorkShiftReducer = (state, actions) => {
	switch (actions.type) {
		case GET_SCHEDULES_WORKSHIFT:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case GET_SCHEDULES_WORKSHIFT_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case GET_SCHEDULES_WORKSHIFT_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				workShifts: actions.payload,
			};
		default:
			return state;
	}
};
